import { render, staticRenderFns } from "./OrderStatusInfo.vue?vue&type=template&id=380694ac&"
import script from "./OrderStatusInfo.vue?vue&type=script&lang=js&"
export * from "./OrderStatusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports